import { render, staticRenderFns } from "./EffectTypeFloatBtns.vue?vue&type=template&id=222774e2&"
import script from "./EffectTypeFloatBtns.vue?vue&type=script&lang=js&"
export * from "./EffectTypeFloatBtns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports